'use client';

import React from 'react';
import { FEEDBACK_THANK_YOU_MESSAGE } from './config';

const FeedbackThankYou = () => {
  return (
    <p className="it-customer-rating-title mb-0" role="status">
      {FEEDBACK_THANK_YOU_MESSAGE}
    </p>
  );
};

export default FeedbackThankYou;
